type Props = {
  description: string;
  onClick: () => void;
};

const ShortDescription: React.FC<Props> = ({
  description,
  onClick: handleClick,
}) => {
  // let charLimit = 47;
  // const isExpanded = false;
  // State to control whether to show full text or truncated text
  // const [isExpanded, setIsExpanded] = useState(false);

  // Toggle between showing more or less
  // const toggleReadMore = () => {
  //   setIsExpanded(!isExpanded);
  // };

  // Check if the description length is more than 100 characters
  // const isLongDescription = description.length > charLimit;

  if (!description) return <></>;

  return (
    <p onClick={handleClick} className="cursor-pointer">
       {description}
      {/* {isExpanded || !isLongDescription
        ? description // Show full description
        : `${description.substring(0, charLimit)}...`}{" "} */}
      {/* Truncated text */}
      {/* {isLongDescription && (
        <span onClick={handleClick} className="read-more-btn text-success cursor-pointer">
          {isExpanded ? "read less" : "read more"}
        </span>
      )} */}
    </p>
  );
};

export default ShortDescription;
